import { memo } from 'react';
import { InfoImage as InfoImageBase, Button } from '@betty/moonlight';
import { InfoImageProps } from './InfoImage.types';

function InfoImage({ close, ...rest }: InfoImageProps) {
  return (
    <InfoImageBase {...rest}>
      <Button
        variant="secondary"
        locKey="close"
        locNS="common"
        size="large"
        width="100%"
        onPress={close}
      />
    </InfoImageBase>
  );
}

export default memo(InfoImage);
